import { z } from 'zod';
import { optionalE164PhoneSchema, requiredE164PhoneSchema } from './common/phone.js';

export const ExplicitConsentSchema = z.object({
    id: z.string().optional(),
    referenceNumber: z.string().optional(),
    nameSurname: z.string().min(1),
    tcIdentityNo: z.string().min(1),
    email: z.string().email(),
    telephoneNo: requiredE164PhoneSchema,
    faxNo: optionalE164PhoneSchema,
    legalRepresentativeName: z.string().optional(),
    legalRepresentativeTc: z.string().optional(),
    residentialAddress: z.string().optional(),
    capAddress: z.string().optional(),
    explicitConsentMethod: z.string().min(1),
    personalData: z.string().min(1),
    historyOfExplicitConsent: z.string().optional(),
    disclosureTextUrl: z.string().optional(),
    consentTextUrl: z.string().optional(),
    disclosureSignedAt: z.string().or(z.date()).optional(),
    consentSignedAt: z.string().or(z.date()).optional(),
    outputDocumentUrl: z.string().optional(),
    status: z.enum(['active', 'inactive']).default('active'),
    createdAt: z.date().optional(),
    updatedAt: z.date().optional(),
});

export const CreateExplicitConsentSchema = ExplicitConsentSchema.omit({
    id: true, createdAt: true, updatedAt: true, referenceNumber: true,
});
export const UpdateExplicitConsentSchema = ExplicitConsentSchema
    .omit({ id: true, createdAt: true, updatedAt: true, referenceNumber: true })
    .partial();
